import { ValueOf } from '@/types/value-of.type'


export const DATE_FORMAT = {
  DEFAULT_FORMAT: 'yyyy-MM-dd',
  FULL_FORMAT: 'yyyy-MM-dd HH:mm:ss',
  DATE_TIME_FORMAT: 'yyyy-MM-dd HH:mm',
  YEAR_FORMAT: 'yyyy',
  YEAR_MONTH_FORMAT: 'yyyy/MM',
  MONTH_DATE_FORMAT: 'MM/dd',
  TIME_FORMAT: 'HH:mm',
} as const
export type DATE_FORMAT = ValueOf<typeof DATE_FORMAT>

export const DATE_FORMAT_EN = {
  DEFAULT_FORMAT: 'yyyy.MM.dd',
  FULL_FORMAT: 'yyyy.MM.dd HH:mm:ss',
  DATE_TIME_FORMAT: 'yyyy.MM.dd HH:mm',
  YEAR_FORMAT: 'yyyy',
  YEAR_MONTH_FORMAT: 'MMM yyyy',
  MONTH_DATE_FORMAT: 'MMM dd',
  TIME_FORMAT: 'HH:mm',
} as const
export type DATE_FORMAT_EN = ValueOf<typeof DATE_FORMAT_EN>

export const DATE_FORMAT_TYPE = {
  DEFAULT_FORMAT: 'DEFAULT_FORMAT',
  FULL_FORMAT: 'FULL_FORMAT',
  DATE_TIME_FORMAT: 'DATE_TIME_FORMAT',
  YEAR_FORMAT: 'YEAR_FORMAT',
  YEAR_MONTH_FORMAT: 'YEAR_MONTH_FORMAT',
  MONTH_DATE_FORMAT: 'MONTH_DATE_FORMAT',
  TIME_FORMAT: 'TIME_FORMAT',
} as const
export type DATE_FORMAT_TYPE = keyof typeof DATE_FORMAT_TYPE
